export enum CorrectionReasonEnum {
  'other' = 'other',
  'rideDistanceCalculatedIncorrectly' = 'ride_distance_calculated_incorrectly',
}

export type CorrectionReasonType =
  | CorrectionReasonEnum.other
  | CorrectionReasonEnum.rideDistanceCalculatedIncorrectly;
